import type { IconProps } from "./Icons";

export const IconReset = ({
  width = 22,
  height = 22,
  color = "currentColor",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M4 8.5V4m0 4.5h4.5M4.6 8.2a8 8 0 1 1-.35 7.05"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
